<template>
  <div :class="['buybuttonVue', $parent.prices.discount > 0.01 && $parent.tax > 1 ? 'discount' : '']" >
    <!-- Show buybutton if item is on stock and no backorder or show buybutton if item is out of stock but backorder is available. Also show if item has not been set to "may not sell"-->
   
   <div v-if="!$root.display.showPriceNoBuyButton ">
      <div v-if="onlyBuyWhenLoggedInCheck">
        <div v-if="(((this.$parent.availability != 0 && !backorder) || (this.$parent.availability == 0 && (backorder || preorder))) && this.$parent.availability != 2) || this.$parent.availability == 5">
          <transition-group :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
            <button :key="1" class="add" v-if="((showAddToBasket && (((this.$parent.availability != 0 || this.$parent.availability != 2) && (!backorder && !preorder)) || (this.$parent.availability == 5)))) && loaded && !this.$root.turbocheckout" @click.prevent="addToBasket(id)" v-html="this.$root.language.wsm_AddToBasket"></button>
            <button :key="1" class="add" v-if="((showAddToBasket && (((this.$parent.availability != 0 || this.$parent.availability != 2) && (!backorder && !preorder)) || (this.$parent.availability == 5)))) && loaded && this.$root.turbocheckout" @click.prevent="addToBasketButReallyFast(id)" v-html="this.$root.language.wsm_Checkout"></button>
            <div :key="2" v-if="(this.$parent.availability == 0 && (backorder || preorder)) && currentQuant == 0 && showAddToBasket">
              <button v-if="backorder" class="add" @click.prevent="showModal = true" v-html="this.$root.language.wsm_AddToBasket"></button>
              <button v-if="!backorder && preorder" class="add notify" @click.prevent="showModal = true"><i class="fas fa-bell"></i> <span v-html="this.$root.language.wsm_Preorder"></span></button>
            </div>
          </transition-group>
          <transition :name="entry ? '' : 'bounce'" :duration="{ enter: 300, leave: 0 }">
            <div class="quantityButtons" v-if="(currentQuant != 0 && showQuant) && loaded && !this.$root.turbocheckout">
              <button class="minus" @click.prevent="adjustQuantity('minus')"><i class="fas fa-minus"></i></button>
              <input disabled v-model="currentQuant" />
              <button class="plus" @click.prevent="adjustQuantity('plus')"><i class="fas fa-plus"></i></button>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- Out of stock, no backorder -->
    <div v-if="this.$parent.availability == 0 && (!backorder && !preorder)">
      <button class="add outOfStock" v-html="this.$root.language.wsm_OutOfStock"></button>
    </div>
    <!-- include backorder modal -->
    <div v-if="this.$parent.availability == 0 && (backorder || preorder)">
      <backorderModal @addToBasket="addToBasket" v-if="showModal" @close="showModal = false" :preorder="preorder" :productid="id" :backorder="backorder" :productname="productname"></backorderModal>
    </div>
    <!-- May not be sold, no backorder -->
    <div v-if="this.$parent.availability == 2  && !this.$root.display.showPriceNoBuyButton">           
      <MessengerButton v-if="this.$parent.locale == 'th-TH' || this.$parent.currencyType == 'THB'"></MessengerButton>
      <button v-else class="add outOfStock" v-html="this.$root.language.wsm_NotForSale"></button>   
    </div>
  </div>
</template>

<script>
  import backorderModal from './backorder';
  import MessengerButton from '../../../integrationtest/src/components/messengerButton.vue'
  export default {
    name: 'buyButton',
    components: {
      backorderModal,
      MessengerButton
    }, 
    data() {
      return {
        currentQuant: 0,
        showAddToBasket: true,
        showModal: false,
        showQuant: "",
        entry: true,
        id: this.$root.id,
        quantity: parseInt(this.$root.quantity),       
        backorder: this.$root.backorder,
        loaded: false,
        productname: this.$root.productname,
        preorder: this.$root.preorder,
      };
    },
    created() {
      this.currentQuant = parseInt(this.$root.quantity)
    },
    mounted() {
      this.loaded = true;
    },
    watch: {
      currentQuant: {
        handler() {
          if (this.currentQuant == 0) {
            this.showQuant = false;
            setTimeout(() => {
              this.showAddToBasket = true;
            }, 100)
          } else {
            if(!this.$root.turbocheckout) {
              this.showAddToBasket = false;
            }
   
            setTimeout(() => {
              this.showQuant = true;
            }, 100)
          }
        }
      }
    },
    methods: {
      setQuantity: function(amount) {
        this.currentQuant = amount;
      },
      addToBasket: async function() {
        var _that = this;
        this.entry = false;
        await axios.get(window.basedir + '/ajaxRequestServlet?mode=UpdateQuantity&payload={"products":[{productID:' + this.id + ',quantity:1}], isPointShop: ' + (this.$root.pointshop ? "Y" : false) + '}', {
          headers: {
            'Content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }).then((response) => {
          if (response.data.errorMessage.length > 0) {
            alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
          } else {
            window.ajaxBasket.refresh();
            this.currentQuant = 1;
            this.$emit('gtag', this.$parent.prices.price)
          }
        });
      },
      async addToBasketButReallyFast() {
        await this.addToBasket();
        window.location = window.basedir + '/checkOutServlet?sirius=/checkout-continue&logintype=guest';
      },
      adjustQuantity: function(type) {
        this.entry = false;
        var newQuant = type == "minus" ? (this.currentQuant - 1) : (this.currentQuant + 1);
        axios.get(window.basedir + '/ajaxRequestServlet?mode=UpdateQuantity&payload={"products":[{productID:' + this.id + ',quantity:' + newQuant + '}], isPointShop: ' + (this.$root.pointshop ? "Y" : false) + '}', {
          headers: {
            'Content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }).then((response) => {
          if (response.data.errorMessage.length > 0) {
            alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
          } else {
            window.ajaxBasket.refresh();
            this.currentQuant = type == 'minus' ? (this.currentQuant - 1) : (this.currentQuant + 1);
          }
        });
      },
    },
    computed: {
      onlyBuyWhenLoggedInCheck: function() {
        if (this.$root.display.OnlyBuyWhenLoggedIn) {
          if (this.$root.display.loggedIn) {
            return true;
          } else {
            return false;
          }
        } else {
          return true
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .buybuttonVue {
    vertical-align: top;
    float: right;
  }
  .discount {
  width:100%;
}
.gallery2020 {
  .buybuttonVue {
  	max-width: 50%;
	width: auto;
  	margin-top: 9px;
  }

}
.add {
  width:100%;
}
  .add {
	background-position: center !important;
	transition: background 0.2s !important;
	border-radius: 3px;
	padding: 5px 10px;
	font-size: 15px;
	-webkit-appearance: none;
	border: 1px solid darkseagreen;
	background: #7caf63;
	color: white;
	float: right;
	cursor: pointer;
	vertical-align: top;
  &:hover{
   // background: darken(#7caf63, 5%);
    background: #5e9244;
  }
    i {
      color: white;
      font-size: 0.8em;
      vertical-align: top;
      margin-top: 2px;
    }
  }
  .notify {
    background: #004570;
    border: 1px solid #004570;
    color:white;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color:white;
      margin-left: 0.3rem;
    }
    &:hover {
      background: #206d9c;
      border: 1px solid #1c73a9;
    }
  }
  .nosale {
    .outOfStock {
      font-size: 0.7em;
      min-height: 22px;
    }
  }
  .outOfStock {
    background: transparent;
    color: #7caf63;
    border: 1px solid #7caf63;
    font-weight: bold;
    cursor: default;
  }
  .grid {
    .add {
      width: 100%;
      padding: 0;
      margin: 0;
      display: block;
      float: none;
      border-radius: 0;
      padding: 6px;
    }
    .quantityButtons {
      height: 29px;
      text-align: left;
      input {
        width: 12%;
        height: 23px;
        min-width: 32px;
      }
    }
  }
  .quantityButtons {
    text-align: right;
    height: 29px;
    button {
      height: 100%;
      background-position: center !important;
      transition: background 0.6s !important;
      border-radius: 3px;
      border-radius: 3px;
      border-radius: 3px;
      padding: 3px 8px;
      -webkit-appearance: none;
      border: 1px solid darkseagreen;
      background: #7caf63;
      color: white;
      display: inline-block;
      margin: 0;
      cursor: pointer;
      .fas {
        color: white;
        font-size: 0.8em;
      }
    }
    .plus {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .minus {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  input {
    width: 40%;
    display: inline-block;
    text-align: center;
    color: #004570 !important;
    background: #ffffff;
    border-top: 1px solid #7caf63;
    border-bottom: 1px solid #7caf63;
    border-right: none;
    border-left: none;
    max-width: 30px;
    font-size: 1.1em;
    font-weight: bold;
    vertical-align: top;
    height: 23px;
    padding-top: 3px;
  }
  .bounce-enter-active {
    animation: bounce-in 0.5s;
  }
  .bounce-leave-active {
    animation: bounce-in 0.5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.02);
    }
    100% {
      transform: scale(1);
    }
  }
  @media screen and (max-width: 700px) {
    .grid {
      .addToBasketButton {
        .add {
          width: 100%;
          min-height: 29px;
        }
        .quantityButtons {
          text-align: right;
          height: 30px;
          margin-left: -3px;
          input {
            height: 24px;
          }
        }
      }
    }
    .list {
      .productActionBar {
        .adminBtn {
          .add {
            width: 100%;
            padding: 7px;
          }
        }
        .addToBasketButton {
          .add {
            width: 100%;
            padding: 7px;
          }
        }
        .quantityButtons {
          height: 30px;
          margin-left: -3px;
          input {
            height: 24px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 440px) {
    .grid {
      .addToBasketButton {
        .quantityButtons {
          text-align: left;
        }
      }
    }
  }
</style>
